import { create } from "zustand";

interface OnboardState {
  referalId: string;
  setReferalId: (referalId: string) => void;
}

const useOnboardStore = create<OnboardState>((set) => ({
  referalId: "",
  setReferalId: (referalId: string) => set({ referalId }),
}));

export default useOnboardStore;
